import { useEffect } from "react";
import ContactFloating from "../../components/contact-floating";
import '../Sponsors/Sponsors.styless.scss';
// Importar logo del sponsor cuando esté disponible
// import CARREPAR_LOGO from '../../assets/sponsors/carrepar-logo.png';

const Sponsors = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="sponsors-page">
            <section className="sponsors-hero section animate__animated animate__fadeIn">
                <div className="container sponsors-container">
                    <h1 className="section-title">Nuestro Sponsor Oficial</h1>
                    
                    <div className="sponsor-intro">
                        <p className="intro-text">
                            En Dindorf trabajamos con los mejores proveedores del sector automotor, 
                            garantizando repuestos de calidad y servicio profesional para nuestros clientes.
                        </p>
                    </div>

                    {/* Sección principal del sponsor */}
                    <div className="sponsor-main">
                        <div className="sponsor-logo-section">
                            {/* Descomentar cuando tengas el logo */}
                            {/* <img src={CARREPAR_LOGO} alt="CARREPAR EAS Logo" className="sponsor-logo" /> */}
                            <div className="sponsor-logo-placeholder">
                                <i className="ri-building-line"></i>
                            </div>
                            <h2 className="sponsor-name">CARREPAR EAS</h2>
                            <p className="sponsor-subtitle">CARREPAR REPUESTOS EAS</p>
                        </div>

                        <div className="sponsor-description">
                            <h3 className="description-title">Nuestro Proveedor de Confianza</h3>
                            <p className="description-text">
                                {/* COMPLETAR: Agregar descripción del sponsor */}
                                CARREPAR EAS es un proveedor líder en repuestos automotrices, 
                                ofreciendo productos de alta calidad para todo tipo de vehículos.
                                Con años de experiencia en el mercado, nos brinda el respaldo 
                                necesario para garantizar la excelencia en nuestros servicios.
                            </p>

                            <div className="sponsor-highlights">
                                <div className="highlight-item">
                                    <div className="highlight-icon">
                                        <i className="ri-checkbox-circle-line"></i>
                                    </div>
                                    <div className="highlight-content">
                                        <h4>Calidad Garantizada</h4>
                                        <p>Repuestos originales y certificados</p>
                                    </div>
                                </div>

                                <div className="highlight-item">
                                    <div className="highlight-icon">
                                        <i className="ri-time-line"></i>
                                    </div>
                                    <div className="highlight-content">
                                        <h4>Disponibilidad</h4>
                                        <p>Stock permanente y entregas rápidas</p>
                                    </div>
                                </div>

                                <div className="highlight-item">
                                    <div className="highlight-icon">
                                        <i className="ri-award-line"></i>
                                    </div>
                                    <div className="highlight-content">
                                        <h4>Experiencia</h4>
                                        <p>Años de trayectoria en el sector</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Productos y servicios del sponsor */}
                    <div className="sponsor-products">
                        <h2 className="products-title">Líneas de Productos</h2>
                        <div className="products-grid">
                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-settings-3-line"></i>
                                </div>
                                <h3>Repuestos de Motor</h3>
                                <p>Partes originales y alternativas para todo tipo de motores</p>
                            </div>

                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-steering-2-line"></i>
                                </div>
                                <h3>Suspensión y Dirección</h3>
                                <p>Componentes de alta calidad para seguridad y confort</p>
                            </div>

                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-stop-circle-line"></i>
                                </div>
                                <h3>Sistema de Frenos</h3>
                                <p>Discos, pastillas y componentes certificados</p>
                            </div>

                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-flashlight-line"></i>
                                </div>
                                <h3>Electricidad</h3>
                                <p>Componentes eléctricos y electrónicos</p>
                            </div>

                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-oil-line"></i>
                                </div>
                                <h3>Lubricantes</h3>
                                <p>Aceites y fluidos de las mejores marcas</p>
                            </div>

                            <div className="product-card">
                                <div className="product-icon">
                                    <i className="ri-tools-line"></i>
                                </div>
                                <h3>Accesorios</h3>
                                <p>Amplia variedad de accesorios automotrices</p>
                            </div>
                        </div>
                    </div>

                    {/* Por qué trabajamos con ellos */}
                    <div className="partnership-section">
                        <h2 className="partnership-title">¿Por qué trabajamos con CARREPAR EAS?</h2>
                        <div className="benefits-grid">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <i className="ri-shield-check-line"></i>
                                </div>
                                <h3>Confiabilidad</h3>
                                <p>
                                    Proveedor de confianza con productos certificados y 
                                    respaldo de garantía en todos los repuestos.
                                </p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <i className="ri-truck-line"></i>
                                </div>
                                <h3>Logística Eficiente</h3>
                                <p>
                                    Entregas rápidas y puntuales que nos permiten 
                                    mantener nuestro compromiso con los clientes.
                                </p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <i className="ri-price-tag-3-line"></i>
                                </div>
                                <h3>Precios Competitivos</h3>
                                <p>
                                    Excelente relación calidad-precio que nos permite 
                                    ofrecer servicios accesibles sin comprometer calidad.
                                </p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <i className="ri-customer-service-line"></i>
                                </div>
                                <h3>Soporte Técnico</h3>
                                <p>
                                    Asesoramiento profesional y soporte constante 
                                    para garantizar la mejor solución.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Call to action */}
                    <div className="sponsor-cta">
                        <div className="cta-content">
                            <h2 className="cta-title">¿Interesado en conocer más sobre nuestros repuestos?</h2>
                            <p className="cta-description">
                                Contáctanos para obtener información sobre los productos y servicios 
                                que ofrecemos con el respaldo de CARREPAR EAS.
                            </p>
                            <button
                                className="cta-button"
                                onClick={() =>
                                    window.open(
                                        'https://wa.me/2635000305?text=Hola,%20quisiera%20información%20sobre%20repuestos',
                                        '_blank'
                                    )
                                }
                            >
                                <i className="ri-whatsapp-line"></i>
                                Consultar por Repuestos
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <ContactFloating />
        </div>
    );
};

export default Sponsors;